<template>
    <div class="ranking w-100 h-100 overflow-hidden d-flex flex-column">
        <div class="custom-background" :style="{ backgroundImage: `url('${$store.state.game.images?.ranking_podium_image}')`}"></div>

        <FullScreen btn_class="btn btn-sm btn-outline-light event-icon-btn position-absolute top-0 start-0 m-3 ranking-logout" />
        <button type="button" class="btn btn-sm btn-outline-light position-absolute top-0 end-0 m-3 ranking-logout" title="Cerrar sesión" @click="logout"><i class="bi bi-box-arrow-left"></i></button>

        <div class="text-center pt-5 pb-2 position-relative" id="ranking-header-region">
            <div class="ranking-subtitle">{{ active_ranking ? active_ranking.name : 'Clasificación general' }}</div>
            <h1 class="mt-1" :style="$store.state.game.styles?.ranking_end">RANKING</h1>
            <!-- TEMP debug text, so the rules behind a sector-triggered
                 ranking are visible while this is still new - a real
                 rendering of the rules (not just their names) comes later. -->
            <div v-if="active_ranking" class="ranking-debug-rules">
                {{ utils.get_ranking_criterion_label(active_ranking.criterion) }} · {{ utils.get_ranking_scope_label(active_ranking.scope) }}
            </div>
        </div>

        <div class="position-absolute top-0 start-0 p-0" id="logos" style="margin-left: 64px">
            <div class="d-flex justify-content-center align-items-center flex-column text-center bg-light rounded-bottom p-3">
                <EventBrand />
            </div>
        </div>

        <div class="flex-fill d-flex align-items-end justify-content-center position-relative ranking-podium">
            <div class="podium-el" v-for="entry in podium_order" :key="entry ? entry.uuid : entry">
                <template v-if="entry">
                    <TeamJerseyBadge v-if="entry.avatar_style && entry.avatar_style.color" :color="entry.avatar_style.color" :size="56" class="mb-2" />
                    <div class="podium-name" :style="$store.state.game.styles?.ranking_end_teams">{{ entry.username }}</div>
                    <div class="podium-score">{{ entry.display_value }}</div>
                    <div class="podium-bar" :class="'podium-rank-' + entry.rank" :style="{ height: podium_height(entry) + '%' }">
                        <span class="podium-rank-number">{{ entry.rank }}</span>
                    </div>
                </template>
            </div>
        </div>

        <div class="ranking-others mx-auto mb-4" v-if="rest.length > 0">
            <div class="ranking-others-row" v-for="entry in rest" :key="entry.uuid">
                <span class="ranking-others-rank">{{ entry.rank }}</span>
                <TeamJerseyBadge v-if="entry.avatar_style && entry.avatar_style.color" :color="entry.avatar_style.color" :size="28" class="me-2" />
                <span class="ranking-others-name">{{ entry.username }}</span>
                <span class="ranking-others-score">{{ entry.display_value }}</span>
            </div>
        </div>
    </div>
</template>

<script>
import FullScreen from '@/components/FullScreen.vue'
import EventBrand from '@/components/EventBrand.vue'
import utils from '@/../../shared/utils'
import TeamJerseyBadge from '@/components/TeamJerseyBadge.vue'
export default {
    name: 'Ranking',
    components: { FullScreen, EventBrand,
        TeamJerseyBadge
    },
    data(){
        return {
            utils: utils,
        };
    },
    mounted(){
        if(window.store.state.network == "connected")
            window.network.wso.send(JSON.stringify({action: window.RPC.UPDATE_VIEW, params: {view: window.router.currentRoute._value.name, activity: (window.store.state.game.question) ? window.store.state.game.question.id : null}}))

        $('.modal-backdrop').remove();
    },
    computed: {
        active_ranking(){
            return this.$store.state.game.active_ranking;
        },
        // A ranking is a configurable scoring rule (see ranking.model.js /
        // server/actions/ranking-action.js) - this view doesn't know or
        // care which sortcode/Ranking subclass produced active_ranking.
        // entries (points, response time, whatever gets registered later),
        // it only renders the generic {label, display_value, rank} shape
        // every Ranking always returns - the actual calculation runs
        // server-side, already "chewed" by the time it gets here. Falls
        // back to the original whole-game, client-computed podium when
        // nothing set active_ranking (the admin's plain "RANKING" button,
        // with no specific ranking config behind it).
        ranked_players(){
            const active = this.$store.state.game.active_ranking;
            if(active && active.entries)
            {
                return active.entries.map((entry) => ({
                    uuid: entry.subject_id,
                    username: entry.label,
                    avatar_style: entry.avatar_style,
                    display_value: entry.display_value,
                    rank: entry.rank,
                }));
            }

            return this.$store.state.game.clients
                .filter((u) => u.role == this.utils.USER_ROLES.PLAYER)
                .map((u) => Object.assign({}, u, { score: this.utils.calc_score(u.data) }))
                .sort((a, b) => b.score - a.score)
                .map((u, idx) => Object.assign(u, { display_value: u.score + ' pts', rank: idx + 1 }));
        },
        top3(){
            return this.ranked_players.slice(0, 3);
        },
        rest(){
            return this.ranked_players.slice(3);
        },
        // Podium display order is 2nd / 1st / 3rd (tallest in the middle),
        // matching the approved mockup - not raw rank order.
        podium_order(){
            return [this.top3[1] || null, this.top3[0] || null, this.top3[2] || null];
        },
    },
    methods: {
        logout(){
            this.utils.reset_client();
        },
        // Purely rank-based, not the raw value - some formulas rank lowest-
        // first (e.g. response time), so "biggest number = tallest bar"
        // would read backwards for those. The view only needs to know who's
        // 1st/2nd/3rd, never by how much.
        podium_height(entry){
            switch(entry.rank){
                case 1: return 100;
                case 2: return 78;
                case 3: return 60;
                default: return 40;
            }
        }
    }
}
</script>

<style scoped>
    .ranking{
        background: radial-gradient(circle at 50% 20%, var(--vc-ink-700), var(--vc-ink-900) 65%);
        color: var(--vc-paper-50);
    }

    .ranking-subtitle{
        font-family: "Archivo", sans-serif;
        font-weight: 700;
        font-size: 0.8rem;
        text-transform: uppercase;
        letter-spacing: 0.14em;
        color: var(--vc-accent-500);
    }

    .ranking-debug-rules{
        font-size: 0.75rem;
        opacity: 0.6;
        margin-top: 4px;
    }

    .ranking-podium{
        gap: 28px;
        padding-bottom: 0;
    }

    .podium-el{
        width: 12vw;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: flex-end;
    }

    .podium-name{
        max-width: 100%;
        overflow-wrap: anywhere;
        line-height: 1.15;
        font-family: "Archivo", sans-serif;
        font-weight: 800;
        font-size: 0.95rem;
        text-transform: uppercase;
        letter-spacing: 0.02em;
        text-align: center;
    }

    .podium-score{
        font-family: "Archivo", sans-serif;
        font-weight: 900;
        font-size: 1.3rem;
        margin-bottom: 10px;
    }

    .podium-bar{
        width: 100%;
        border-radius: 8px 8px 0 0;
        display: flex;
        align-items: center;
        justify-content: center;
        transition: height 0.6s ease;
    }

    .podium-rank-number{
        font-family: "Archivo", sans-serif;
        font-weight: 900;
        font-size: 2.2rem;
    }

    .podium-rank-1{
        background: rgba(0, 167, 175, 0.12);
        border-top: 5px solid var(--vc-accent-500);
    }
    .podium-rank-1 .podium-rank-number{ color: var(--vc-accent-500); }
    .podium-rank-1 .podium-score{ color: var(--vc-accent-500); }

    .podium-rank-2{
        background: rgba(255, 255, 255, 0.08);
        border-top: 4px solid #c9ccd1;
    }
    .podium-rank-2 .podium-rank-number{ color: #c9ccd1; }

    .podium-rank-3{
        background: rgba(255, 255, 255, 0.06);
        border-top: 4px solid #b9793f;
    }
    .podium-rank-3 .podium-rank-number{ color: #b9793f; }

    .ranking-others{
        width: 60%;
        max-width: 900px;
        background: rgba(0, 0, 0, 0.2);
        border-radius: 10px;
        overflow: hidden;
    }

    .ranking-others-row{
        display: flex;
        align-items: center;
        gap: 16px;
        padding: 12px 20px;
        border-bottom: 1px solid rgba(255, 255, 255, 0.08);
    }
    .ranking-others-row:last-child{
        border-bottom: none;
    }

    .ranking-others-rank{
        width: 24px;
        font-family: "Archivo", sans-serif;
        font-weight: 800;
    }

    .ranking-others-name{
        flex: 1;
        min-width: 0;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        font-weight: 600;
    }

    .ranking-others-score{
        font-family: "Archivo", sans-serif;
        font-weight: 800;
    }

    #logos{
        height: 150px;
        max-height: 150px;
        width: 20vw;
    }

    .ranking-logout{
        z-index: 30;
    }

    /* Phones/small tablets: the 12vw podium columns were narrower than a
       team name (names spilled into each other), the 150px logo box sat on
       top of the "RANKING" header and the others list was too narrow. */
    @media (max-width: 768px){
        #logos{
            height: 64px;
            max-height: 64px;
            width: 96px;
            margin-left: 60px !important;
        }
        #logos > div{
            padding: 6px !important;
            height: 100%;
        }
        #ranking-header-region{
            padding-top: 76px !important;
        }
        #ranking-header-region h1{
            font-size: 1.9rem;
        }
        .ranking-podium{
            gap: 10px;
            padding: 0 10px;
        }
        .podium-el{
            width: auto;
            flex: 1 1 0;
            min-width: 0;
            max-width: 120px;
        }
        .podium-name{
            font-size: 0.75rem;
            display: -webkit-box;
            -webkit-line-clamp: 2;
            -webkit-box-orient: vertical;
            overflow: hidden;
        }
        .podium-score{
            font-size: 1.05rem;
            margin-bottom: 6px;
        }
        .podium-rank-number{
            font-size: 1.6rem;
        }
        .ranking-others{
            width: calc(100% - 24px);
        }
        .ranking-others-row{
            gap: 10px;
            padding: 10px 12px;
        }
    }
</style>
